export const SalaryFrequency = {
	PER_DAY: 'per-day',
	PER_MONTH: 'per-month',
	PER_YEAR: 'per-year'
};
